export default __webpack_public_path__ + "static/media/3.ba8573c5.webp";